document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-comparison-sample]');
  if (!link || event.defaultPrevented || event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const product = Array.from(document.querySelectorAll('product-single[data-product-id]'))
    .find((element) => element.dataset.productId === link.dataset.productId);
  const picker = product?.querySelector('variant-radios, variant-selects, variant-mixed-inputs');
  if (!picker || typeof picker.onVariantChange !== 'function') return;

  const value = link.dataset.optionValue;
  if (!value) return;

  const radio = Array.from(picker.querySelectorAll('input[type="radio"]'))
    .find((input) => input.value === value && !input.disabled);
  const option = Array.from(picker.querySelectorAll('select:not([disabled]) option'))
    .find((item) => item.value === value && !item.disabled);
  const control = radio || option?.parentElement;
  if (!control) return;

  event.preventDefault();
  if (radio) {
    radio.click();
  } else {
    control.value = value;
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  control.focus({ preventScroll: true });
  window.scrollTo({
    top: 0,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
  });
});
